<template>
  <div
    :id="questionId"
    :type="attributeType"
    class="questionModel"
    @clearValue="clearValue()"
    @disableInput="disableInput()"
    @enableInput="enableInput()"
    @enableRequired="enableRequired()"
    @removeRequired="removeRequired()"
  >
    <b-row class="mx-0">
      <b-col cols="10">
        <label class="questionLabelStyle"
          ><span v-if="isRequired" class="requiredStar">* </span>{{ label }}</label
        >
        <div v-if="helpText">
          <p class="helpTextStyle"><span v-html="helpText"></span></p>
        </div>
      </b-col>
      <b-col>
        <response-history
          v-show="selectedAnswerId"
          :options="options"
          :questionId="questionId"
          :surveyType="validationsType"
          :type="'multiPicklist'"
        />
      </b-col>
    </b-row>
    <b-col>
      <validation-observer ref="observer">
        <validation-provider
          ref="provider"
          v-slot="validationContext"
          :rules="`${isRequired ? 'required' : ''}`"
        >
          <b-form-checkbox-group
            :id="questionId + '_value'"
            v-model="selected"
            :options="options"
            :state="getValidationState(validationContext)"
            aria-describedby="validationFeedback"
            class="mb-3"
            stacked
            text-field="Label__c"
            value-field="Value__c"
            @change="limitCheck($event)"
            @input="changeItem($event)"
          >
          </b-form-checkbox-group>
          <b-form-invalid-feedback id="validationFeedback"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </validation-observer>
    </b-col>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import ResponseHistory from './ResponseHistory.vue';

  export default {
    name: 'MultiPicklist',
    components: {
      ResponseHistory,
    },
    props: [
      'label',
      'options',
      'dependencyMap',
      'questionId',
      'answer',
      'dependentQuestion',
      'requiredQuestions',
      'attributeType',
      'validationsType',
      'helpText',
      'selectedLimit',
      'multiPicklistRestriction',
    ],
    data() {
      return {
        selected: [],
        formData: this.value || {},
        selectedAnswerAndId: {},
        selectedAnswer: '',
        selectedAnswerId: '',
        count: 0,
        isRequired: false,
        optionsToErase: [],
      };
    },
    watch: {
      async validationTrigger(newVal, oldVal) {
        if (
          this.requiredQuestions.includes(this.questionId) &&
          newVal.includes(this.validationsType)
        ) {
          let data = [];
          data[0] = this.questionId;
          data[1] = await this.$refs.observer.validate();
          this.$store.commit(this.validationsType, data);
        }
      },
    },
    created() {
      for (let i = 0; i < Object.keys(this.options).length; i++) {
        this.selectedAnswerAndId[this.options[i]['Value__c']] = this.options[i]['Id'];
      }
      if (this.answer === undefined || this.answer[0]['Saved_Value_Long__c'] === undefined) {
        this.selectedAnswer = undefined;
      } else {
        this.selectedAnswer = this.answer[0]['Saved_Value_Long__c'];
        for (const index of this.options.keys()) {
          if (this.selectedAnswer.includes(this.options[index]['Value__c'])) {
            this.selected.push(this.options[index]['Value__c']);
          }
        }
      }
      if (this.answer === undefined) {
        this.selectedAnswerId = undefined;
      } else {
        this.selectedAnswerId = this.answer[0]['Id'];
      }

      if (this.answer !== undefined) {
        this.emitValue(this.answer[0]['Saved_Value_Long__c']);
      }
      if (this.requiredQuestions.includes(this.questionId)) {
        this.isRequired = true;
      } else {
        this.isRequired = false;
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
      this.collectOptionsToErase();
    },
    computed: {
      ...mapGetters(['validationTrigger']),
    },
    mounted() {
      if (document.getElementById(this.questionId).classList.contains('hideElement')) {
        this.isRequired = false;
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
      let answersWithDependency = [];
      this.selected.forEach(x => {
        if (Object.keys(this.dependencyMap).includes(this.selectedAnswerAndId[x])) {
          answersWithDependency.push(x);
        }
      });
      let i = 0;
      do {
        this.checkDependentQuestion(
          answersWithDependency[i],
          this.selectedAnswerAndId[answersWithDependency[i]],
        );
        i++;
      } while (i < answersWithDependency.length);
      this.count = 1;
      this.setRestriction();
    },
    methods: {
      ...mapActions(['dirtySurvey']),
      setRestriction() {
        if (
          this.multiPicklistRestriction != undefined &&
          this.selected.includes(this.multiPicklistRestriction['Value__c'])
        ) {
          this.selected = [this.multiPicklistRestriction['Value__c']];
          for (let order in this.optionsToErase) {
            document
              .getElementById(this.questionId + '_value_BV_option_' + this.optionsToErase[order])
              .setAttribute('hideElement', 'true');
          }
        } else {
          for (let order in this.optionsToErase) {
            document
              .getElementById(this.questionId + '_value_BV_option_' + this.optionsToErase[order])
              .removeAttribute('hideElement');
          }
        }
      },
      collectOptionsToErase() {
        if (this.multiPicklistRestriction != undefined) {
          this.options.forEach(element => {
            if (element.Value__c != this.multiPicklistRestriction['Value__c']) {
              this.optionsToErase.push(element.Order__c - 1);
            }
          });
        }
      },
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required) {
          return dirty || validated ? valid : null;
        }
      },
      limitCheck(event) {
        if (event.length > this.selectedLimit) {
          alert(
            `You have reached the limit of ${this.selectedLimit} selected answers for this question.`,
          );
          this.selected = this.selected.slice(0, this.selectedLimit);
        }
      },
      changeItem(event) {
        this.setRestriction();
        this.dirtySurvey(this.validationsType);
        let lovId;
        for (let ev in event) {
          if (this.dependencyMap[this.selectedAnswerAndId[event[ev]]] !== undefined) {
            lovId = this.selectedAnswerAndId[event[ev]];
            break;
          } else {
            lovId = this.selectedAnswerAndId[event[event.length - 1]];
          }
        }
        this.$emit('input', { value: event.toString(), id: this.selectedAnswerId });
        this.disableDependentQuestion(lovId);
      },
      clearValue() {
        this.selected = [];
      },
      removeRequired() {
        this.isRequired = false;
      },
      enableRequired() {
        if (this.requiredQuestions.includes(this.questionId)) {
          this.isRequired = true;
        }
      },
      emitValue(savedValue) {
        this.$emit('input', { value: savedValue.toString(), id: this.selectedAnswerId });
      },
      disableDependentQuestion(lovId) {
        if (this.dependentQuestion != null) {
          this.dependentQuestion.forEach(element => {
            document.getElementById(element).dispatchEvent(new Event('disableInput'));
            document.getElementById(element).dispatchEvent(new Event('removeRequired'));
          });

          this.dependentQuestion.forEach(element => {
            if (typeof this.dependencyMap[lovId] !== 'undefined') {
              if (this.dependencyMap[lovId].includes(element)) {
                document.getElementById(element).dispatchEvent(new Event('enableInput'));
                document.getElementById(element).dispatchEvent(new Event('enableRequired'));
              } else {
                document.getElementById(element).dispatchEvent(new Event('disableInput'));
                document.getElementById(element).dispatchEvent(new Event('removeRequired'));
              }
            } else {
              if (this.count == 1) {
                let parentElement = document.getElementById(element);
                parentElement.dispatchEvent(new Event('clearValue'));
              }
            }
          });
        }
      },
      checkDependentQuestion(selectedAnswer, selectedAnswerId) {
        if (selectedAnswer) {
          let lovId = selectedAnswerId;
          this.disableDependentQuestion(lovId);
        } else if (this.dependentQuestion) {
          this.dependentQuestion.forEach(element => {
            document.getElementById(element).dispatchEvent(new Event('disableInput'));
          });
        }
      },
      disableInput() {
        document.getElementById(this.questionId).classList.add('hideElement', 'pl-5');
        document.getElementById(this.questionId + '_value').setAttribute('hideElement', 'true');
        for (let index = 0; index < this.options.length; index++) {
          document
            .getElementById(this.questionId + '_value_BV_option_' + index)
            .setAttribute('hideElement', 'true');
        }
      },
      enableInput() {
        document.getElementById(this.questionId).classList.remove('hideElement');
        document.getElementById(this.questionId + '_value').removeAttribute('hideElement');
        for (let index = 0; index < this.options.length; index++) {
          document
            .getElementById(this.questionId + '_value_BV_option_' + index)
            .removeAttribute('hideElement');
        }
      },
    },
  };
</script>
